import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import {
  ICreateCustomReservationThreshold,
  ICustomReservationThreshold,
  IEditCustomReservationThreshold
} from "../interfaces/endpoints/ICustomReservationThreshold";
import { serialize } from "../utils/serializeToQueryString";

export type GetAllThresholdsParamsType = {
  searchKeyword?: string;
  pageIndex?: number;
  pageSize?: number;
};

// Paged: the table runs to thousands of rows once a country-wide change is applied. Each row arrives
// with its endpoints and operator already named, so the list never looks an id up on its own.
export const getAllThresholds = async (
  params: GetAllThresholdsParamsType
): Promise<IAxiosResponse<IPagination<ICustomReservationThreshold>>> => {
  return axios.get(
    `/v1/CustomReservationThreshold${serialize(params)}`
  );
};

export const getThresholdById = async (
  id: number
): Promise<IAxiosResponse<ICustomReservationThreshold>> => {
  return axios.get(`/v1/CustomReservationThreshold/${id}`);
};

export const createThreshold = async (
  body: ICreateCustomReservationThreshold
): Promise<IAxiosResponse<ICustomReservationThreshold>> => {
  return axios.post("/v1/CustomReservationThreshold", body);
};

export const updateThreshold = async (
  id: number,
  body: IEditCustomReservationThreshold
): Promise<IAxiosResponse<ICustomReservationThreshold>> => {
  return axios.put(`/v1/CustomReservationThreshold/${id}`, body);
};

export const deleteThreshold = async (
  id: number
): Promise<boolean> => {
  return axios.delete(`/v1/CustomReservationThreshold/${id}`);
};
